<template>
  <!--  <li class="hor-list-item" v-on:click="filterFeed(option)">-->
  <li class="hor-list-item">
    <router-link
      :to="'/community/feed/' + option.name.replaceAll(' ', '-').toLowerCase()"
      class="feed-option"
    >
      {{ option.name }}
    </router-link>
    <!--    <span>{{option}}</span>-->
    <div
      ref="highlight"
      class="select"
    />
  </li>
</template>

<script>
import { useFeedStore } from '@/store/FeedStore';
import { useUserStore } from '@/store/UserStore';
import { gsap } from 'gsap';
import { mapStores } from 'pinia';

export default {
  name: 'FeedOption',
  props: ['option'],
  watch: {
    $route () {
      this.filterFeed(this.$route.params.option);
      const { highlight } = this.$refs;
      if (this.option.name.replaceAll(' ', '-').toLowerCase() === this.feedStore.getFilterType) {
        gsap.to(highlight, {
          autoAlpha: 1,
          duration: .6,
          ease: 'power4.inOut',
          scaleX: 1
        });
      } else {
        gsap.to(highlight, {
          autoAlpha: 1,
          duration: .6,
          ease: 'power4.inOut',
          scaleX: 0
        });
      }
    }
  },
  mounted () {
    const { highlight } = this.$refs;
    gsap.set(highlight, { autoAlpha : 0, scaleX: 0 });
    this.filterFeed(this.$route.params.option);
    if (this.option.name.replaceAll(' ', '-').toLowerCase() === this.feedStore.getFilterType) {
      gsap.to(highlight, {
        autoAlpha: 1,
        duration: .6,
        ease: 'power4.inOut',
        scaleX: 1
      });
    }
  },
  methods : {
    filterFeed (filterType) {
      this.feedStore.filterFeed(filterType);
    }
  },
  computed: {
    ...mapStores(useFeedStore, useUserStore)
  }
};
</script>

<style scoped>
.hor-list-item {
  display: inline-block;
  margin-right: 10px;
  font-weight: 700;
  font-size: .825em;
  color: #595a5a;
  text-align: left;
}
.feed-option {
  color:rgb(102, 101, 101);
  font-weight:700;
  letter-spacing: .02em;
  margin-left:2px;
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;

}
/*.hor-list-item:hover {
  cursor: pointer;
  border-bottom: 3px solid #2c3e50;
}*/
.select {
  height: 3px;
  background-color: #2c3e50;
}
</style>
